import { useState } from "react";
import { Dropdown, DropdownMenu, DropdownItem } from "reactstrap";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { CLASSIFICATION_CREATE_PERMISSION } from "../../../permissions";
import { classificationActions } from "../../enum";
import "./Classification.scss";

const { EDIT_CLASSIFICATION, DELETE_CLASSIFICATION } = classificationActions;

const Classification = ({
    item,
    selectedClassification,
    setSelectedClassification,
    handleActionModal,
}) => {
    const [dropdownOpen, toggle] = useState(false);

    const options = [
        {
            value: EDIT_CLASSIFICATION,
            label: "Edit",
        },
        {
            value: DELETE_CLASSIFICATION,
            label: "Delete",
        },
    ];

    const handleChange = (option) => {
        handleActionModal(option);
        toggle(false);
    };

    return (
        <Dropdown
            isOpen={dropdownOpen}
            direction='up'
            toggle={() => toggle(false)}>
            <div
                onMouseOver={() =>
                    item?.classificationId ===
                        selectedClassification?.classificationId &&
                    !dropdownOpen &&
                    toggle(true)
                }>
                <div
                    className={`classification ${
                        item?.classificationId ===
                        selectedClassification?.classificationId
                            ? "active__classification"
                            : ""
                    }`}
                    onClick={() => setSelectedClassification(item)}>
                    {item?.name}
                </div>
            </div>
            <DropdownMenu>
                <div className='dropdown__menu__content'>
                    {options?.map((option, i) => (
                        <ComponentAccessControl
                            key={i}
                            baseResources={CLASSIFICATION_CREATE_PERMISSION}>
                            <DropdownItem
                                onClick={() => handleChange(option.value)}>
                                {option.label}
                            </DropdownItem>
                        </ComponentAccessControl>
                    ))}
                </div>
            </DropdownMenu>
        </Dropdown>
    );
};

export default Classification;
